// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2vnsu","messages":"Chat_messages__3Iwa9","dateDivider":"Chat_dateDivider__WPJXp"};